(ns frontend.view.reports.custom.diamond-edge-ventures-tables
  (:require
   [frontend.view.reports.custom.diamond-edge-common :as diamond-edge-common]
   [frontend.view.reports.custom.diamond-edge-ventures.report-1-total-engagement :as report-1-data]
   [frontend.view.reports.custom.diamond-edge-ventures.report-2-total-engagement :as report-2-data]
   [common.localization :as loc]
   [reagent.core :as r]
   [frontend.view.components.clipboard :as clipboard]
   [frontend.exports.excel :as excel]
   [frontend.utils :as fu]
   [ui.components.card.view :as card]))

(defn tenant-table
  [{:keys [view-name header-row data-rows footer-row]}]
  [card/card
   [card/header
    [:div.d-flex.align-items-center
     [:span.title-h3.d-inline-block.pr-2 view-name]]

    [:div.d-flex.justify-content-end
     [:i.fal.fa-copy.mr-3.pointer
      {:title    (loc/tr :copy-to-clipboard)
       :on-click (fn [_]
                   (clipboard/copy-as-tsv (concat [header-row]
                                                  data-rows
                                                  [footer-row])))}]
     [:i.fal.fa-file-excel.pointer
      {:title    (loc/tr :save-as-excel)
       :on-click (fn [_]
                   (excel/export-array-data
                    view-name
                    (concat [header-row] data-rows [footer-row])))}]]]
   [card/body
    [:table.zap-simple-table.zap-simple-table--md.w-100
     [:thead
      [:tr
       (->> header-row
            (map-indexed (fn [idx heading]
                           ^{:key (str view-name "-header-" idx)}
                           [:th heading]))
            (doall))]]
     [:tbody
      {:key (str view-name "-body")}
      (->> data-rows
           (map-indexed
            (fn [row-idx row-data]
              [:tr
               {:key (str view-name "-row-" row-idx)}
               (->> row-data
                    (map-indexed (fn [idx cell-data]
                                   [:td
                                    {:key        (str view-name "-" row-idx "-" idx)
                                     :class-name (if (= 0 idx) "string-value" "number-value")}
                                    cell-data]))
                    (doall))]))
           (doall))]
     [:tfoot
      [:tr
       (->> footer-row
            (map-indexed (fn [idx footer-cell-data]
                           [:td
                            {:key (str view-name "-footer-" idx)}
                            footer-cell-data]))
            (doall))]]]]])

(defn report-1
  []
  (let [reports-state (r/atom (diamond-edge-common/get-filter-default-values))]
    (fn []
      (let [data (report-1-data/oppos-by-status-or-deal-type reports-state)
            [_ total-count] (last data)]
        [:div
         [diamond-edge-common/filters reports-state]
         [:div.row
          [:div
           [tenant-table
            {:view-name  "Total Engagement - UTD"
             :header-row [" " "Engagement" "% of Total"]
             :data-rows  (->> data
                              (butlast)
                              (mapv (fn [[lbl cnt]]
                                      [lbl cnt (str (fu/show-pct (/ cnt total-count)))])))
             :footer-row ["Total" total-count "100%"]}]]]]))))

(defn report-2
  []
  (let [reports-state (r/atom (diamond-edge-common/get-filter-default-values))]
    (fn []
      (let [data (report-2-data/oppos-by-status-or-deal-type reports-state)]
        [:div
         [diamond-edge-common/filters reports-state]
         [:div.row
          [:div
           [tenant-table
            {:view-name  "Total Engagement - by stage"
             :header-row ["" "Stop" "Hold" "Active" "Portfolio" "Transfer to BU" "Stage-up" "Total"]
             :data-rows  (->> data
                              (butlast))
             :footer-row (last data)}]]]]))))

(defn view
  [_]
  (fn []
    [:div.ml-4
     [report-1]
     [:div.mt-4]
     [report-2]]))
